/* eslint-disable func-style */
const ReceivableTab = () => import('../pages/chargeManagement/ReceivableTab');
const ReceivableDetailK12 = () => import('../pages/chargeManagement/ReceivableDetailK12');
const ChargeInfo = () => import('../components/ChargeInfo');
const ReceivableWrapper = () => import('@/pages/chargeManagement/wrapper.vue');
const GainDetailsEmpty = () => import('@/pages/chargeManagement/GainDetailsEmpty.vue');
const ChargeStandard = () => import('../pages/chargeManagement/ChargeStandard');
const GainChargeInfoImport = () => import('../components/importChargeInfo/GainChargeInfoImport');
const ChargeControl = () => import('../pages/chargeManagement/recTabItem/ChargeControl');
const ChargeProgress = () => import('../pages/chargeManagement/recTabItem/ChargeProgress');
const ChargeProgressK12 = () => import('../pages/chargeManagement/recTabItem/ChargeProgressK12');
const ImportTag = () => import('../pages/chargeManagement/recTabItem/ImportTag');
const TicketManage = () => import('../pages/chargeManagement/recTabItem/TicketManage');
const VerifyRecord = () => import('../pages/chargeManagement/recTabItem/VerifyRecord');
const GainDetailsEmptyImportNormal = () => import('../pages/chargeManagement/GainDetailsEmptyImportNormal');
const GainDetailsEmptyImportAdd = () => import('../pages/chargeManagement/GainDetailsEmptyImportAdd');
const GainMultiplex = () => import('../pages/chargeManagement/GainMultiplex');
const GainPayeeSeek = () => import('../pages/chargeManagement/GainPayeeSeek');
const GainPaidList = () => import('../pages/chargeManagement/GainPaidList');
const GainArrearsPage = () => import('../pages/chargeManagement/GainArrearsPage');
const GainRefund = () => import('../pages/chargeManagement/GainRefund');
const GainRefundRecord = () => import('../pages/chargeManagement/GainRefundRecord');
const GainCreditPage = () => import('../pages/chargeManagement/GainCreditPage');
const GainDeratePage = () => import('../pages/chargeManagement/GainDeratePage');
const GainDeferredPayment = () => import('../pages/chargeManagement/GainDeferredPayment');
const GainArrearsDetail = () => import('../pages/chargeManagement/GainArrearsDetail');
const RightPanel = () => import('../components/RightPanel');
const GainPaidListDetail = () => import('../pages/chargeManagement/GainPaidListDetail');
const GainRefundDetail = () => import('../pages/chargeManagement/GainRefundDetail');
const GainRefundRecordDetail = () => import('../pages/chargeManagement/GainRefundRecordDetail');
const ChargeStandardSetting = () => import('../pages/chargeManagement/ChargeStandardSetting');
const ChargeProjectAutoPublish = () => import('../pages/chargeManagement/ChargeProjectAutoPublish');
const DsfInformation = () => import('../pages/chargeManagement/DsfInformation');
const ImportExcel = () => import('../pages/chargeManagement/ImportExcel');
const SettingAutoPublishImportExcel = () => import('../pages/chargeManagement/SettingAutoPublishImportExcel');
const DsfExcel = () => import('../pages/chargeManagement/DsfExcel');
const GainDetailAppliedRate = () => import('../pages/chargeManagement/GainDetailAppliedRate');
const GainDetailRegister = () => import('../pages/chargeManagement/GainDetailRegister');
const chargeManagement = [
	{ path: '/ReceivableHomePage', name: 'ReceivableHomePage', component: ReceivableWrapper, meta: { type: 'gain' } },
	{
		path: '/ReceivableTab',
		component: ReceivableTab,
		children: [
			{ path: '/', name: 'ReceivableDetail', component: GainDetailsEmpty, meta: { parent: '/ReceivableHomePage' } },
			{ path: '/', name: 'ReceivableDetailK12', component: ReceivableDetailK12, meta: { parent: '/ReceivableHomePage' } },
			{ path: 'ChargeControl', name: 'ChargeControl', component: ChargeControl, meta: { parent: '/ReceivableHomePage' } },
			{ path: 'ChargeProgress', name: 'ChargeProgress', component: ChargeProgress, meta: { parent: '/ReceivableHomePage' } },
			{ path: 'ChargeProgressK12', name: 'ChargeProgressK12', component: ChargeProgressK12, meta: { parent: '/ReceivableHomePage' } },
			{ path: 'TicketManage', name: 'TicketManage', component: TicketManage, meta: { parent: '/ReceivableHomePage' } },
			{ path: 'VerifyRecord', name: 'VerifyRecord', component: VerifyRecord, meta: { parent: '/ReceivableHomePage' } },
		],
	},
	{ path: '/ImportTag', name: 'ImportTag', component: ImportTag },
	{ path: '/ChargeInfo/:type', name: 'ChargeInfo', component: ChargeInfo, meta: { parent: '/ReceivableHomePage' } },
	{ path: '/ChargeStandard', name: 'ChargeStandard', component: ChargeStandard, meta: { parent: '/ReceivableHomePage' } },
	{ path: '/GainChargeInfoImport', name: 'GainChargeInfoImport', component: GainChargeInfoImport, meta: { parent: '/ReceivableHomePage' } },
	{ path: '/GainDetailsEmptyImportNormal/:isUpdate', name: 'GainDetailsEmptyImportNormal', component: GainDetailsEmptyImportNormal, meta: { parent: '/ReceivableHomePage' } },
	{ path: '/GainDetailsEmptyImportAdd/:isUpdate', name: 'GainDetailsEmptyImportAdd', component: GainDetailsEmptyImportAdd, meta: { parent: '/ReceivableHomePage' } },
	{ path: '/GainMultiplex', name: 'GainMultiplex', component: GainMultiplex, meta: { parent: '/ReceivableHomePage' } },
	{ path: '/GainPayeeSeek', name: 'GainPayeeSeek', component: GainPayeeSeek, meta: { parent: '/ReceivableHomePage' } },
	{
		path: '/GainPaidList',
		name: 'GainPaidList',
		component: GainPaidList,
		meta: { parent: '/ReceivableHomePage' },
		children: [
			{
				path: '/PaidListRightPanel',
				name: 'PaidListRightPanel',
				component: RightPanel,
				children: [
					{ // 列表右滑框
						path: '/GainPaidListDetail/:rowData',
						name: 'GainPaidListDetail',
						component: GainPaidListDetail,
					},
				],
			},
		],
	},
	{
		path: '/GainArrearsPage',
		name: 'GainArrearsPage',
		component: GainArrearsPage,
		meta: { parent: '/ReceivableHomePage' },
		children: [
			{
				path: '/ArrearsRightPanel',
				name: 'ArrearsRightPanel',
				component: RightPanel,
				children: [
					{ // 列表右滑框
						path: '/GainArrearsDetail/:rowData',
						name: 'GainArrearsDetail',
						component: GainArrearsDetail,
						meta: { parent: '/ReceivableHomePage' },
					},
				],
			},
		],
	},
	{
		path: '/GainRefund',
		name: 'GainRefund',
		component: GainRefund,
		meta: { parent: '/ReceivableHomePage' },
		children: [
			{
				path: '/GainRefundRightPanel',
				name: 'GainRefundRightPanel',
				component: RightPanel,
				children: [
					{
						path: '/GainRefundDetail/:rowData',
						name: 'GainRefundDetail',
						component: GainRefundDetail,
						meta: { parent: '/ReceivableHomePage' },
					},
				],
			},
		],
	},
	{
		path: '/GainRefundRecord',
		name: 'GainRefundRecord',
		meta: { parent: '/ReceivableHomePage' },
		component: GainRefundRecord,
		children: [
			{
				path: '/GainRefundRecordRightPanel',
				name: 'GainRefundRecordRightPanel',
				component: RightPanel,
				children: [
					{
						path: '/GainRefundRecordDetail/:rowData',
						name: 'GainRefundRecordDetail',
						component: GainRefundRecordDetail,
						meta: { parent: '/ReceivableHomePage' },
					},
				],
			},
		],
	},
	{ path: '/GainCreditPage', name: 'GainCreditPage', component: GainCreditPage, meta: { parent: '/ReceivableHomePage' } },
	{ path: '/GainDeratePage', name: 'GainDeratePage', component: GainDeratePage, meta: { parent: '/ReceivableHomePage' } },
	{ path: '/GainDeferredPayment', name: 'GainDeferredPayment', component: GainDeferredPayment, meta: { parent: '/ReceivableHomePage' } },
	{
		path: '/ChargeProjectAutoPublish',
		name: 'ChargeProjectAutoPublish',
		component: ChargeProjectAutoPublish,
	},
	{
		path: '/ChargeStandardSetting',
		name: 'ChargeStandardSetting',
		component: ChargeStandardSetting,
	}, {
		path: '/ImportExcel',
		name: 'ImportExcel',
		component: ImportExcel,
	},
	{
		path: '/SettingAutoPublishImportExcel',
		name: 'SettingAutoPublishImportExcel',
		component: SettingAutoPublishImportExcel,
	},
	{ path: '/GainDetailAppliedRate', name: 'GainDetailAppliedRate', component: GainDetailAppliedRate },
	{
		path: '/GainDetailRegister',
		name: 'GainDetailRegister',
		component: GainDetailRegister,
	},
	{
		path: '/DsfInformation',
		name: 'DsfInformation',
		component: DsfInformation,
	}, {
		path: '/DsfExcel',
		name: 'DsfExcel',
		component: DsfExcel,
	},
];

export default chargeManagement;
